import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../../shared/area-restitra.shared.module';
import { ProcorManutencaoComunicadoComponent } from './procor-manutencao-comunicado.component';
import { ProcorManutencaoComunicadoIncluirAlterarComponent } from './procor-manutencao-comunicado-incluir-alterar/procor-manutencao-comunicado-incluir-alterar.component';
import { ProcorManutencaoComunicadoRouterngModule } from './router/procor-manutencao-comunicado.router';
import { ProcorManutencaoComunicadoService } from './service/procor-manutencao-comunicado.service';

@NgModule({
  imports: [
      CommonModule,
      AreaRestritaSharedModule,
      ProcorManutencaoComunicadoRouterngModule
  ],
  declarations: [
    ProcorManutencaoComunicadoComponent,
    ProcorManutencaoComunicadoIncluirAlterarComponent
  ],
  providers: [
    ProcorManutencaoComunicadoService
  ]
})
export class ProcorManutencaoComunicadoModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/procor-manutencao-comunicado/procor-manutencao-comunicado.module.ts